import Page from '../../components/layouts/page'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import UploadImagesButton from './upload_images_button'
import ImagesTable from '../../components/images_table'

const Images = () => {
  const { airlineID, cycleID } = useParams()
  const { pathname } = useLocation()
  const base = `/airlines/${airlineID}/cycles/${cycleID}/images`
  if (pathname !== base && pathname !== `${base}/`) return <Navigate to={base} replace />

  return (
    <Page title={'Images'} buttons={<UploadImagesButton />}>
      <ImagesTable />
    </Page>
  )
}

export default Images
